(function () {
  var fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 });
  var nativeFetch = window.fetch.bind(window);
  var PROP = '_regalo';
  var working = false;

  function attr(el, name) { return parseInt(el.getAttribute(name), 10) || 0; }
  function root() { return document.querySelector('[data-mb-ship]'); }
  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function money(cents) { return fmt.format(cents / 100); }

  function flagged(it, giftId) {
    return !!(giftId && it.variant_id === giftId && it.properties && it.properties[PROP]);
  }

  /* Solo UNA pieza es gratis: los duplicados y las unidades extra si cuentan. */
  function readCart(cart, giftId) {
    var total = 0, key = null, claimed = false;
    (cart.items || []).forEach(function (it) {
      if (flagged(it, giftId) && !claimed) {
        claimed = true;
        key = it.key;
        if (it.quantity > 1) total += it.original_price * (it.quantity - 1);
      } else {
        total += it.original_line_price;
      }
    });
    return { total: total, giftKey: key, count: cart.item_count };
  }

  function shippingLine(r, total) {
    var shipT = attr(r, 'data-threshold');
    if (!shipT) return '';
    if (total < shipT) {
      return (r.getAttribute('data-msg') || '').replace('[amount]', '<b>' + money(shipT - total) + '</b>');
    }
    return r.getAttribute('data-done') || '';
  }

  function state(r, info) {
    var shipT = attr(r, 'data-threshold');
    var giftT = attr(r, 'data-gift-threshold');
    var max = Math.max(shipT, giftT) || shipT;
    var total = info.total;
    var has = !!info.giftKey;

    var s = {
      sub: '',
      action: null,
      chip: false,
      warn: false,
      pct: max ? Math.min(100, Math.round((total / max) * 100)) : 0,
      mark: max && giftT && giftT < max ? Math.round((giftT / max) * 100) : 0,
      giftDone: !!(giftT && total >= giftT),
      shipDone: !!(shipT && total >= shipT)
    };

    if (giftT && has && total < giftT) {
      s.msg = 'Tu marcador ya no es de regalo. Te faltan <b>' + money(giftT - total) + '</b> para recuperarlo.';
      s.action = { label: 'Quitar el marcador', kind: 'remove' };
      s.warn = true;
      s.sub = shippingLine(r, total);
    } else if (giftT && !has && total >= giftT) {
      s.msg = 'Ganaste un marcador de regalo.';
      s.action = { label: 'Agregarlo a mi pedido', kind: 'add' };
      s.sub = shippingLine(r, total);
    } else if (giftT && total < giftT) {
      s.msg = (r.getAttribute('data-gift-msg') || '').replace('[amount]', '<b>' + money(giftT - total) + '</b>');
      s.sub = shippingLine(r, total);
    } else {
      s.msg = shippingLine(r, total);
      s.chip = has;
    }
    return s;
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function sectionIds() {
    var cd = drawerEl();
    if (cd && typeof cd.getSectionsToRender === 'function') {
      try { return cd.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return null;
  }

  function applyResponse(json) {
    var cd = drawerEl();
    if (cd && json && json.sections && typeof cd.renderContents === 'function') {
      try { cd.renderContents(json); return true; } catch (e) {}
    }
    return false;
  }

  function mutate(path, payload) {
    var ids = sectionIds();
    if (ids) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }
    return nativeFetch(routeRoot() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) { return res.json(); });
  }

  function onAction(kind) {
    if (working) return;
    var r = root();
    if (!r) return;
    var giftId = attr(r, 'data-gift-id');
    if (!giftId) return;
    working = true;

    nativeFetch(routeRoot() + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var info = readCart(cart, giftId);
        if (kind === 'add' && !info.giftKey) {
          return mutate('cart/add.js', { items: [{ id: giftId, quantity: 1, properties: { _regalo: 'true' } }] });
        }
        if (kind === 'remove' && info.giftKey) {
          return mutate('cart/change.js', { id: info.giftKey, quantity: 0 });
        }
        return null;
      })
      .then(function (json) {
        working = false;
        if (json && applyResponse(json)) { setTimeout(paintAll, 60); return; }
        window.location.reload();
      })
      .catch(function () { working = false; window.location.reload(); });
  }

  function buildBox(host) {
    var el = host.querySelector('.mb-ship-mini');
    if (!el) {
      el = document.createElement('div');
      el.className = 'mb-ship-mini';
      el.innerHTML =
        '<span class="mb-ship-mini-msg"></span>' +
        '<span class="mb-ship-mini-track"><i class="mb-ship-mini-mark"></i><i class="mb-ship-mini-fill"></i></span>' +
        '<span class="mb-ship-mini-scale"><i class="mb-ship-mini-lbl mb-ship-mini-lbl--gift">Regalo</i><i class="mb-ship-mini-lbl mb-ship-mini-lbl--ship">Envio gratis</i></span>' +
        '<span class="mb-ship-mini-sub"></span>' +
        '<button type="button" class="mb-ship-mini-btn" hidden></button>';
      host.insertBefore(el, host.firstChild);
      el.querySelector('.mb-ship-mini-btn').addEventListener('click', function () {
        onAction(this.getAttribute('data-kind'));
      });
    }
    return el;
  }

  function paintAll() {
    var r = root();
    if (!r) return;
    var giftId = attr(r, 'data-gift-id');
    nativeFetch(routeRoot() + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var info = readCart(cart, giftId);
        var s = state(r, info);
        var empty = info.count === 0;

        document.querySelectorAll('[data-mb-ship]').forEach(function (bar) {
          bar.hidden = empty;
          if (empty) return;
          var m = bar.querySelector('[data-mb-ship-msg]');
          var f = bar.querySelector('[data-mb-ship-fill]');
          var c = bar.querySelector('[data-mb-gift-chip]');
          if (m) m.innerHTML = s.msg + (s.sub ? ' <span class="mb-ship-sub">' + s.sub + '</span>' : '');
          if (f) f.style.width = s.pct + '%';
          if (c) c.hidden = !s.chip;
        });

        document.querySelectorAll('.drawer__footer, .cart__footer').forEach(function (host) {
          var el = buildBox(host);
          el.hidden = empty;
          if (empty) return;
          el.classList.toggle('mb-ship-mini--warn', !!s.warn);
          el.querySelector('.mb-ship-mini-msg').innerHTML = s.msg;
          el.querySelector('.mb-ship-mini-fill').style.width = s.pct + '%';

          var mark = el.querySelector('.mb-ship-mini-mark');
          var lg = el.querySelector('.mb-ship-mini-lbl--gift');
          var ls = el.querySelector('.mb-ship-mini-lbl--ship');
          if (s.mark > 0) {
            mark.hidden = false;
            mark.style.left = s.mark + '%';
            mark.classList.toggle('is-passed', s.giftDone);
            lg.hidden = false;
            lg.classList.toggle('is-passed', s.giftDone);
          } else {
            mark.hidden = true;
            lg.hidden = true;
          }
          ls.classList.toggle('is-passed', s.shipDone);

          var sub = el.querySelector('.mb-ship-mini-sub');
          sub.innerHTML = s.sub;
          sub.hidden = !s.sub;

          var btn = el.querySelector('.mb-ship-mini-btn');
          if (s.action) {
            btn.hidden = false;
            btn.textContent = s.action.label;
            btn.setAttribute('data-kind', s.action.kind);
          } else {
            btn.hidden = true;
          }
        });
      })
      .catch(function () {});
  }

  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var isCart = href.indexOf('/cart/add') !== -1 || href.indexOf('/cart/change') !== -1 || href.indexOf('/cart/update') !== -1 || href.indexOf('/cart/clear') !== -1;
    return nativeFetch.apply(this, arguments).then(function (res) {
      if (isCart) setTimeout(paintAll, 250);
      return res;
    });
  };

  document.addEventListener('DOMContentLoaded', paintAll);
  document.addEventListener('shopify:section:load', paintAll);
  document.addEventListener('mb:cart:changed', function () { setTimeout(paintAll, 200); });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-drawer, .cart-drawer, #cart-icon-bubble, cart-remove-button, .quantity__button')) {
      setTimeout(paintAll, 400);
    }
  });
  if (document.readyState !== 'loading') paintAll();
})();
